<template>
    <div class="container-fluid mt-5">
        <div v-if="loadingProducts" class="container w-100 py-5 my-5 d-flex justify-content-center">
            <span class="loader"></span>
        </div>
        <div v-if="!loadingProducts" class="container">
            <div v-if="products.length > 0" class="row">
                <PricingItem v-for="item in products" :key="item.id" :product_id="item.id" />
            </div>
        </div>
    </div>
</template>

<script>
import PricingItem from '../components/PricingItem.vue'
import { getProducts } from '../services/stripe.service';


export default {
    components: {
        PricingItem
    },
    data() {
        return {
            animationSpeed: 1,
            products: [],
            loadingProducts: true,
        }
    },
    created() {
        getProducts()
            .then(({ data }) => {
                this.products = data
            })
            .finally(() => {
                this.loadingProducts = false
            })
    },
}
</script>

<style lang="scss" scoped>
.loader {
    width: 48px;
    height: 48px;
    display: inline-block;
    position: relative;
}

.loader::after,
.loader::before {
    content: '';
    box-sizing: border-box;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 2px solid #FFF;
    position: absolute;
    left: 0;
    top: 0;
    animation: animloader 2s linear infinite;
}

.loader::after {
    animation-delay: 1s;
}

@keyframes animloader {
    0% {
        transform: scale(0);
        opacity: 1;
    }

    100% {
        transform: scale(1);
        opacity: 0;
    }
}
</style>